import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";

const fmt = (n) => (n === null || n === undefined || n === "" || Number.isNaN(Number(n)) ? "" : new Intl.NumberFormat("en-CA", { minimumFractionDigits: Number.isInteger(Number(n)) ? 0 : 2, maximumFractionDigits: 2 }).format(Number(n)));
export const parseMoney = (s) => {
  const clean = String(s ?? "").replace(/[^0-9.]/g, "");
  if (clean === "" || clean === ".") return null;
  const n = Number(clean);
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : null;
};

// Dollar amount field: accepts "$184,500.50" or "184500.5", no step rounding, no scroll-wheel changes.
export default function MoneyInput({ value, onChange, placeholder = "0.00", ...rest }) {
  const [text, setText] = useState(fmt(value));
  useEffect(() => { if (parseMoney(text) !== (value ?? null)) setText(fmt(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <Input
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={text}
      placeholder={placeholder}
      onChange={(e) => { const t = e.target.value; if (/^[$\s0-9,.]*$/.test(t)) { setText(t); onChange(parseMoney(t)); } }}
      onBlur={() => setText(fmt(parseMoney(text)))}
      onWheel={(e) => e.currentTarget.blur()}
      {...rest}
    />
  );
}
